// extracted by mini-css-extract-plugin
export default {"comparisonName":"FilterNameTab_comparisonName__zf-NJ"};